import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PendingApprovalCard from '../../../pages/Home/PendingApprovalCard';
import { useManagerReportsMode } from '../../../hooks/useManagerReportsMode';
import EmployeesList from './EmployeesList';
import { ManagerReportsModeSwitch } from '../../components/ManagerReportsModeSwitch';
import { useServerFeature } from '../../../../../hooks/useServerFeature';

export const MyTeamOverview: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const [reportsMode, setReportsMode] = useManagerReportsMode('myteam');
  const isApprovalProcessesVisible = useServerFeature('Approval_Processes');

  return (
    <>
      <Row>
        <Col className="text-end">
          <ManagerReportsModeSwitch
            value={reportsMode}
            onChange={setReportsMode}
          />
        </Col>
      </Row>
      <Row>
        <Col md={isApprovalProcessesVisible ? 8 : 12}>
          <EmployeesList />
        </Col>
        {isApprovalProcessesVisible && (
          <Col md={4}>
            <PendingApprovalCard />
          </Col>
        )}
      </Row>
    </>
  );
};
